// DeepLinkButton — opens a bl181 admin URL in a new tab.
//
// Spec §empty/loading/error: if the YAML flags is_broken=true, render
// disabled with the "Link under review — ask Butler Buddy instead"
// empty-state. Adds rel="noopener noreferrer" so the target page can't
// navigate the opener (security + telemetry hygiene).

import { ExternalLink, LinkIcon } from 'lucide-react'

import type { DeepLink } from './types'

interface DeepLinkButtonProps {
  link: DeepLink
}

export function DeepLinkButton({ link }: DeepLinkButtonProps) {
  if (link.is_broken) {
    return (
      <span
        role="note"
        className="inline-flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-200"
        data-testid="help-deep-link-broken"
      >
        <LinkIcon aria-hidden="true" className="h-4 w-4" />
        Link under review — ask in chat instead.
      </span>
    )
  }
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="help-deep-link"
      className="inline-flex items-center gap-2 rounded-lg border border-butler-500/40 bg-butler-500/10 px-3 py-2 text-sm font-medium text-butler-600 transition hover:bg-butler-500/20 dark:border-butler-300/50 dark:bg-butler-500/10 dark:text-butler-200"
    >
      <ExternalLink aria-hidden="true" className="h-4 w-4" />
      {link.label}
    </a>
  )
}
